import { render } from "./PresentationInformation.vue?vue&type=template&id=51a75633"
import script from "./PresentationInformation.vue?vue&type=script&lang=js"
export * from "./PresentationInformation.vue?vue&type=script&lang=js"

import "./PresentationInformation.vue?vue&type=style&index=0&id=51a75633&lang=scss"

import exportComponent from "/home/runner/work/stpancras-backstage-app/stpancras-backstage-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__